import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

export const Table = forwardRef(function Table({ className, ...props }, ref) {
  return <table ref={ref} className={cn('ui-table', className)} {...props} />;
});

export const TableHeader = forwardRef(function TableHeader({ className, ...props }, ref) {
  return <thead ref={ref} className={cn('ui-table-header', className)} {...props} />;
});

export const TableBody = forwardRef(function TableBody({ className, ...props }, ref) {
  return <tbody ref={ref} className={cn('ui-table-body', className)} {...props} />;
});

export const TableRow = forwardRef(function TableRow({ className, ...props }, ref) {
  return <tr ref={ref} className={cn('ui-table-row', className)} {...props} />;
});

export const TableHead = forwardRef(function TableHead({ className, ...props }, ref) {
  return <th ref={ref} className={cn('ui-table-head', className)} {...props} />;
});

export const TableCell = forwardRef(function TableCell({ className, ...props }, ref) {
  return <td ref={ref} className={cn('ui-table-cell', className)} {...props} />;
});
